<template>
	<div id="loyout">
		<layoutHeader></layoutHeader>
		<router-view></router-view>
	</div>
</template>

<script>
import layoutHeader from "./header/header";

export default {
	name: "layout",
	components: {
		layoutHeader,
	},
};
</script>

<style>
.el-input__inner {
	padding: 0 5px;
}

.el-card__body {
	padding: 0 10px !important;
}
</style>
